import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';
import { BreadcrumbSchema } from '../SEO/StructuredData';

const Breadcrumb = ({ items = [] }) => {
  const allItems = [
    { label: 'Home', path: '/' },
    ...items
  ];

  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-6" aria-label="Breadcrumb">
        {allItems.map((item, index) => (
          <React.Fragment key={index}>
            {index === 0 ? (
              <Link 
                to={item.path} 
                className="flex items-center text-blue-600 hover:text-blue-800 transition-colors"
              >
                <HomeIcon className="w-4 h-4 mr-1" />
                {item.label}
              </Link>
            ) : (
              <Link 
                to={item.path} 
                className="text-blue-600 hover:text-blue-800 transition-colors"
              >
                {item.label}
              </Link>
            )}
            {index < allItems.length - 1 && (
              <ChevronRightIcon className="w-4 h-4 text-gray-400" />
            )}
          </React.Fragment>
        ))}
      </nav>
  );
};

export default Breadcrumb;
